import React from "react";
import { Toast } from "devextreme-react";
import SignalRService from 'src/controllers/SignalRService';

class ErrorBoundary extends React.Component {

    constructor(props) {
        super(props);
        this.state = { hasError: false, errorInfo: null };
        this.hide = this.hide.bind(this);
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, info) {

        let message = {
            extension: localStorage.getItem("faExtension"),
            userId: parseInt(localStorage.getItem("faUserId")),
            message: "error: " + error
        };

        SignalRService.consoleLog(message);

        console.error("GLOBAL ERROR CAUGHT:", error, info);
        this.setState({ errorInfo: info });
    }

    hide() {
        this.setState({
            hasError: false
        });
    };

    render() {
        return (
            <>
                <Toast
                    visible={this.state.hasError}
                    message=" Something went wrong, please contact support."
                    type="error"
                    onHiding={this.hide}
                    height={55}
                    width={300}
                    position={{ at: 'top center', my: 'top center', offset: '0 20' }}
                />
                {this.props.children}
            </>
        );
    }
}

export default ErrorBoundary;
